import React, { useState, useCallback } from 'react';
import { Modal, Button } from "react-bootstrap";
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import "./pdfModal.css";
import {Box} from "@mui/material";
import t from "../../Utils/Translation";

function PDFModal({ buttonStyle = {} }) {
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const i18n = localStorage.getItem("i18n");
    let fileUrl;
    if (i18n === "en") {
        fileUrl = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/greenwave/GreenWave+AR-Game+Guidelines_EN.pdf";
    } else if (i18n === "bg") {
        fileUrl = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/greenwave/GreenWave+AR-Game+Guidelines_BG.pdf";
    } else if (i18n === "pt") {
        fileUrl = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/greenwave/GreenWave+AR-Game+Guidelines_PT.pdf";
    } else if (i18n === "el") {
        fileUrl = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/greenwave/GreenWave+AR-Game+Guidelines_GR.pdf";
    } 
 
    //const fileUrl = "https://lykio-dev-data.s3.eu-central-1.amazonaws.com/units/eu_projects/greenwave/GreenWave-AR+Game+Configuration+and+How+to+Play+(1).pdf";

    return (
        <div>
            <Button 
                onClick={() => setIsOpen(true)} 
                variant="outline-secondary" 
                className="float-end" 
                size="sm"
                style={buttonStyle}
            >
                Guidelines
            </Button>
            
            <Modal show={isOpen} onHide={handleClose} fullscreen={true}>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center flex-grow-1">{t('Guidelines')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Box height={'80vh'} position={'relative'}>
                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
                            <Viewer 
                                fitToWidth={false}
                                initialZoom={1}
                                fileUrl={fileUrl} 
                                plugins={[defaultLayoutPluginInstance]} 
                                />
                        </Worker>
                    </Box>
                </Modal.Body>
                <Modal.Footer style={{justifyContent:'center'}}>
                    <Button 
                        variant="outline-secondary" 
                        className="float-end" 
                        size="sm" 
                        style={{width:'5rem'}}
                        onClick={handleClose}>
                        {t('Close')}
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default PDFModal;
